/**
 * Created by tofaelraju on 10/15/17.
 */
import React from 'react';
import globalStyles from '../../utility/styles';

const PageHeader =({title})=> <h1 style={globalStyles.header}>{title}</h1>

export default PageHeader;


// WEBPACK FOOTER //
// ./src/screens/shared/page-header.js